module.exports = __webpack_public_path__ + "img/10_Distal-T.4fa85b87.png";